import { Flex } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

const SyncSkeleton = () => {
  return (
    <Flex flexDirection="column" alignItems="flex-end" data-testid="sync-skeleton">
      <SkeletonComponent height="17px" width="60px" mb="2px" />
      <SkeletonComponent width="141px" height="17px" />
    </Flex>
  );
};

export default SyncSkeleton;
